import { SHORT_URL_REPORT_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import downloadReport from 'root/src/client/logic/form/thunks/downloadReport'

export default {
	[SHORT_URL_REPORT_MODULE_ID]: [
		{
			action: downloadReport,
		},
	],
}
